import React from 'react'

import { useTranslation } from 'react-i18next'

import { Language } from '~/shared/constants'
import { TPageProps } from '~/shared/types'
import { KitRadioOptionsView } from '~/shared/views'

import { ENERGY_VALUE_V1_OPTIONS } from './constants'

const T_PREFIX = 'onboarding.energyValueV1'

const EnergyValueV1: React.FC<TPageProps> = (props) => {
  const { t } = useTranslation()
  const title = t(`${T_PREFIX}.title`)
  const question = t(`${T_PREFIX}.title`, { lng: Language.EN })

  return (
    <KitRadioOptionsView
      title={title}
      options={ENERGY_VALUE_V1_OPTIONS}
      question={question}
      isReverse={false}
      {...props}
    />
  )
}

export default EnergyValueV1
